import { Popover } from "@/components/Popover/Popover";
import PersonInCircleIcon from "@medoma/components/icons/PersonInCircleIcon";
import { Trans, useLingui } from "@lingui/react/macro";
import { Heading } from "@medoma/components/Heading/Heading";
import styles from "./PatientResponsiblePopover.module.scss";
import EmployeeName from "../EmployeeName/EmployeeName";

export const PatientResponsiblePopover = ({
  employeeId,
}: {
  employeeId: number;
}) => {
  const { t } = useLingui();

  return (
    <Popover
      trigger={{
        custom: (
          <div className={styles.personIcon}>
            <PersonInCircleIcon />
          </div>
        ),
        ariaLabel: t`Visa patientansvarig`,
      }}
    >
      <div className={styles.content}>
        <Heading level="h2" size="h3" weight="medium">
          <Trans>Patientansvarig</Trans>
        </Heading>
        <EmployeeName employeeId={employeeId} showCompetence={false} />
      </div>
    </Popover>
  );
};
